import React from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import './Unauthorized.css';

import { useNavigate } from "react-router-dom"; // Make sure to install and import react-router-dom


export const Unauthorized = () => {

  const navigate = useNavigate();

  const goBack = () => {
    if (window.history.length > 2) {
      // Only navigate back if there is sufficient history
      navigate(-1);
    } else {
      // If no history exists, go to home
      navigate("/");
    }
  };

  return (
    <Container fluid className="dark-page">
      <Row className="h-100 align-items-center">
        <Col className="text-center">
          <h1 className="display-1">401</h1>
          <p className="lead">Unauthorized</p>
          <p>Yo need to be logged in to access this page</p>
          <Button variant="outline-light" onClick={goBack} className="mx-2">
            Go Back
          </Button>
          <Button variant="outline-light" href="/" className="mx-2">
            Go Home
          </Button>
        </Col>
      </Row>
    </Container>
  );
};
